// extracted by mini-css-extract-plugin
export default {"hatvSubheaderContainer":"HatvSubheader_hatvSubheaderContainer__YcSbh","ai_flower_logo":"HatvSubheader_ai_flower_logo__hmJ-S","headerText":"HatvSubheader_headerText__InsQa"};